import { render, staticRenderFns } from "./relationWe.vue?vue&type=template&id=f03ab106&scoped=true&"
import script from "./relationWe.vue?vue&type=script&lang=js&"
export * from "./relationWe.vue?vue&type=script&lang=js&"
import style0 from "./relationWe.vue?vue&type=style&index=0&id=f03ab106&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03ab106",
  null
  
)

export default component.exports